module.exports = __webpack_public_path__ + "assets/img/head2-en.b5c38be6.png";